<div class="row">
  <div class="col-md-12">
    <div class="error-template">
      <h1>Oops!</h1>
      <h2>Looks like your account does not exist in FinregE.</h2>
      <div class="error-details">
        Please contact your department SuperUser to request access.
      </div>
    </div>
  </div>
</div>
